import { AppointmentPhase } from "components";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  selectedPhases: server.dto.AppointmentPhases[];
  onChange: (phases: server.dto.AppointmentPhases[]) => void;
}

export const AppointmentPhaseMultiPicker = ({ selectedPhases, onChange }: Props) => {
  return <div className="flex-column gap-small">
    {serverReference.appointmentPhases.map((phase) =>
      <div key={phase.value}>
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("appointmentPhases")}
          onChange={() => {
            if (selectedPhases.includes(phase.value)) {
              onChange(selectedPhases.filter(p => p !== phase.value));
            } else {
              onChange([...selectedPhases, phase.value]);
            }
          }}
          checked={selectedPhases.includes(phase.value)}
          label={<AppointmentPhase value={phase.value} displayLabel />}
        />
      </div>
    )}
  </div>
}